

import React from 'react';
import { useNavigate } from 'react-router-dom';

const CompletedBooking = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const bookings = [
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010015",
      amount: "₹900.00",
      status: "Cancelled",
    },
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010015",
      amount: "₹790.00",
      status: "Completed",
    },
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010015",
      amount: "₹900.00",
      status: "Cancelled",
    },
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010015",
      amount: "₹900.00",
      status: "Cancelled",
    },
  ];

  // Function to handle the redirection
  const handleMoreDetails = (bookingId) => {
    // Navigate to the booking details page, passing the bookingId as a parameter
    navigate('/profile/c-detail');
  };

  return (
    <div className="p-4  flex justify-center w-full">
      <div className="w-full rounded-lg ">
        {/* Booking Cards */}
        <div className="space-y-4 ">
          {bookings.map((booking, index) => (
            <div
              key={index}
              className="rounded-lg p-4 flex flex-col space-y-3 border border-gray-200 bg-gray-100"
            >
              {/* Date and Time */}
              <div className="flex justify-between items-center text-sm text-gray-600">
                <span className="font-semibold text-gray-800">
                  {booking.date} {booking.timeStart}
                </span>
                <span>to</span>
                <span className="font-semibold text-gray-800">
                  {booking.date} {booking.timeEnd}
                </span>
              </div>

              {/* Location */}
              <div className="text-sm text-gray-500 font-medium">
                {booking.location}
              </div>

              {/* Booking ID and Amount */}
              <div className="flex justify-between text-sm text-gray-600">
                <span className="font-semibold">Booking ID</span>
                <span className="text-gray-700">{booking.bookingId}</span>
              </div>
              <div className="flex justify-between text-sm text-gray-600">
                <span className="font-semibold">Total Amount</span>
                <span className="text-gray-700">{booking.amount}</span>
              </div>

              {/* Status */}
              <div className="flex justify-between items-center text-sm">
                <span className="font-semibold">Booking Status</span>
                <span
                  className={`font-semibold ${
                    booking.status === "Completed"
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {booking.status}
                </span>
              </div>

              {/* More Details Link */}
              <div className="text-right">
                <button
                  onClick={() => handleMoreDetails(booking.bookingId)} // Call the function with bookingId
                  className="text-[#FF9630] font-semibold text-sm hover:underline"
                >
                  More Details &gt;
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompletedBooking;
